import React from "react"
import { Link } from "react-router-dom"
import Footer from "../components/Footer"
import Header from "../components/Header"
import { connect } from "react-redux"
import ProtectedContent from "./ProtectedContent"

class Resources extends React.Component {
  /*componentDidMount() {
    const user = netlifyIdentity.currentUser()
    if (user === null) {
      netlifyIdentity.open()
    }
  }*/

  render() {
    return (
      <div>
        <Header />

        <div className="container">
          {Object.keys(this.props.user).length ? (
            <div>
              <h1 style={{ marginTop: "30px", textAlign: "center" }}>
                Teaching Resources
              </h1>
              <p style={{ textAlign: "center" }}>Choose your level</p>
              <div style={{ textAlign: "center" }}>
                <Link to="/resources-primary-1">
                  <button className="hollow-purple-button">Primary 1</button>
                </Link>
                <Link to="/resources-primary-2">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Primary 2
                  </button>
                </Link>
                <Link to="/resources-primary-3">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Primary 3
                  </button>
                </Link>
                <Link to="/resources-primary-4">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Primary 4
                  </button>
                </Link>
                <Link to="/resources-primary-5">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Primary 5
                  </button>
                </Link>
                <Link to="/resources-primary-6">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Primary 6
                  </button>
                </Link>
              </div>
              <div style={{ marginTop: "20px", textAlign: "center" }}>
                <Link to="/resources-prep-1">
                  <button className="hollow-purple-button">
                    Preparatory 1
                  </button>
                </Link>
                <Link to="/resources-prep-2">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Preparatory 2
                  </button>
                </Link>
                <Link to="/resources-prep-3">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Preparatory 3
                  </button>
                </Link>
              </div>
              <div
                style={{
                  marginTop: "20px",
                  textAlign: "center",
                  marginBottom: 100,
                }}
              >
                <Link to="/resources-secondary-1">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Secondary 1
                  </button>
                </Link>
                <Link to="/resources-secondary-2">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Secondary 2
                  </button>
                </Link>
                <Link to="/resources-secondary-3">
                  <button
                    className="hollow-purple-button"
                    style={{ marginLeft: "20px" }}
                  >
                    Secondary 3
                  </button>
                </Link>
              </div>
            </div>
          ) : (
            <ProtectedContent />
          )}
        </div>

        <Footer />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps)(Resources)



// WEBPACK FOOTER //
// ./src/components/Resources.js